import { render, staticRenderFns } from "./CardTarjaTVZFullScreen.vue?vue&type=template&id=110529aa&scoped=true"
import script from "./CardTarjaTVZFullScreen.vue?vue&type=script&lang=js"
export * from "./CardTarjaTVZFullScreen.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTVZFullScreen.vue?vue&type=style&index=0&id=110529aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110529aa",
  null
  
)

export default component.exports